import { render } from "./StockReportDetailsPage.vue?vue&type=template&id=0161cdb2&scoped=true&ts=true"
import script from "./StockReportDetailsPage.vue?vue&type=script&lang=ts"
export * from "./StockReportDetailsPage.vue?vue&type=script&lang=ts"

import "./StockReportDetailsPage.vue?vue&type=style&index=0&id=0161cdb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0161cdb2"]])

export default __exports__